export default __webpack_public_path__ + "static/1996-08-11_sharc_ICMPC.pdf";